<template>
  <div>
    <img v-if="isSelfEnr" v-show="this.logoSrc" :src="this.logoSrc" alt="provider" class="provider-mobile-icon" />
    <div class="info-box" role="alert" aria-live="assertive">
      <div class="info-icon">
        <img src="@Shared/assets/images/InfoIconFilled.png" alt="warning" />
      </div>
      <div class="info-box-content">
        <div v-if="isSelfEnr" class="info-text1">You are enrolling with {{ providerName }}.</div>
        <div v-else class="info-text1">You are applying with {{ providerName }}.</div>
        <div v-if="isSelfEnr" class="info-text2">Click <span class="here-link"
            @click="routeToProviderSearchPage">here</span> to enroll with a different Provider.</div>
        <div v-else class="info-text2">Click <span class="here-link" @click="routeToProviderSearchPage">here</span> to
          apply with a different Provider.</div>
      </div>
      <img v-show="this.logoSrc" :src="this.logoSrc" alt="provider" class="provider-icon" />
    </div>
  </div>
</template>

<script>

export default {
  name: "InfoBox",
  props: {
    providerName: {
      type: String
    },
    logoSrc: {
      type: String
    },
    isSelfEnr: {
      type: Boolean
    }
  },
  methods: {
    routeToProviderSearchPage() {
      if(this.isSelfEnr){
        window.location.href = process.env.VUE_APP_PATIENT_ENROLL + '/search';
        window.location.reload();//remove this
      }
      else{
        window.location.href = process.env.VUE_APP_PATIENT_ENROLL + '/search';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
img {
  max-width: 100%;
  max-height: 50px;
  mix-blend-mode: darken;
}

.here-link {
  text-decoration: underline;
  cursor: pointer;
}

.provider-icon {
  margin: 0 25px 0 0;

  @media (max-width: 768px) {
    display: none;
  }

}

.provider-mobile-icon {
  max-width: 100%;
  max-height: 50px;
  margin: 0 0 20px 14px;

  @media (min-width: 769px) {
    display: none;
  }
}

.info-icon {
  height: 25px;
  width: 25px;
  margin: 0 0 30px 15px;
  flex: none;

  @media (max-width: $grid-breakpoint-sm) {
    margin: 0 5px 70px 15px;
  }
}

.info-box {
  height: 105px;
  width: 98%;
  display: flex;
  align-items: center;
  border-left: 5px solid #087193;
  background-color: #ffffff;
  box-shadow: 0 2px 14px 0 rgba(119, 151, 178, 0.23);
  margin: 0 0 30px 10px;
  padding-right: 10px;

  @media (max-width: $grid-breakpoint-sm) {
    width: 95%;
    height: 125px;
  }

  .info-box-content {
    font-size: 14px;
    line-height: 22px;
    color: $color_stephs-grey;
    margin: 0 auto 5px 10px;

    @media (max-width: $grid-breakpoint-sm) {
      margin-bottom: 15px;
      width: fit-content;
    }

    .info-text1 {
      font-weight: 700;
      font-size: 14px;
      line-height: 23px;
      margin-top: 7px;
      margin-right: auto;
    }

    .info-text2 {
      font-weight: 700;
      font-size: 14px;
      line-height: 23px;
      margin-top: 10px;
      margin-right: auto;
      color: #007AA3
    }
  }
}
</style>